import React, { useEffect, useRef, useState } from 'react';
import { Alert, Spin } from 'antd';
import { ingestionApi } from '../ingestionApi';
import { setupScene, frameCamera, loadModelFromBlob } from './babylonScene';

export function ModelViewer({ itemId, assetId, format, itemType, onLoaded }) {
    const canvasRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const onLoadedRef = useRef(onLoaded);
    onLoadedRef.current = onLoaded;

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return undefined;
        let disposed = false;

        const { engine, scene, camera } = setupScene(canvas);
        const onResize = () => engine.resize();
        window.addEventListener('resize', onResize);

        (async () => {
            try {
                const blob = await ingestionApi.getAssetBlob(itemId, assetId);
                if (disposed) return;
                const ext = format === 'babylon' ? '.babylon' : '.glb';
                const result = await loadModelFromBlob(scene, blob, ext);
                if (disposed) return;
                frameCamera(camera, result.meshes, itemType);
                onLoadedRef.current?.(result);
                setLoading(false);
            } catch (e) {
                if (!disposed) {
                    setError(e.message || 'Failed to load model');
                    setLoading(false);
                }
            }
        })();

        return () => {
            disposed = true;
            window.removeEventListener('resize', onResize);
            engine.dispose();
        };
    }, [itemId, assetId, format, itemType]);

    return (
        <div style={{ position: 'relative', width: '100%', height: 320 }}>
            <canvas
                ref={canvasRef}
                style={{ width: '100%', height: '100%', borderRadius: 6, outline: 'none', display: 'block' }}
            />
            {loading && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Spin tip="Loading model…" />
                </div>
            )}
            {error && (
                <Alert type="error" message={error} showIcon style={{ position: 'absolute', top: 8, left: 8, right: 8 }} />
            )}
        </div>
    );
}
